import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Radium from "radium";

class PositionBox extends Component {
  render() {
    const { position, history } = this.props;
    const { slug, title, subtitle } = position;
    const historyProps = {
      pathname: `/position/${slug}`,
      state: { position }
    };

    return (
      <div className="col-md-4" style={boxStyle}>
        <div
          className="card"
          style={cardStyle}
          onClick={() => history.push(historyProps)}
        >
          <div className="card-body">
            <h5>{title}</h5>
            <span>{subtitle}</span>
          </div>
        </div>
      </div>
    );
  }
}

const boxStyle = {
  marginTop: "20px"
};

const cardStyle = {
  ":hover": {
		boxShadow:
			"0px 0px 16px rgba(188, 188, 188, 0.16), 0px 0px 8px rgba(121, 121, 121, 0.05)"
  },
  userSelect: "none",
  cursor: "pointer",
  minHeight: "160px",
  padding: "20px 0px 0px 20px",
  border: "1px solid #EBEBEB",
  borderRadius: "8px",
  boxShadow:
    "0px 8px 16px rgba(188, 188, 188, 0.16), 0px 2px 8px rgba(33, 33, 33, 0.08)"
};

export default withRouter(Radium(PositionBox));
